module.exports = __webpack_public_path__ + "img/send-email.49278b6a.svg";